import { useEffect, useState } from 'react'
import { CallJson } from 'app/types/entities'
import { gqlFetchList } from 'app/lib/graphqlClient'
import { queueCallProcessing } from 'app/lib/callProcessing'
import { notifyError, notifySuccess } from 'app/services/notify.client'
import { logError } from 'lib/logging'

type CallsResult = { hits: CallJson[]; total: number }

export type UseCallDataExtractionReturn = {
  calls: CallsResult | undefined
  transcribeCall: (callId: string) => Promise<void>
}

export function useCallDataExtraction(): UseCallDataExtractionReturn {
  const [calls, setCalls] = useState<CallsResult>()

  useEffect(() => {
    gqlFetchList<CallJson>(
      'calls',
      { search: 'type:extraction' },
      'id direction callerName callerPhone duration status createdDate',
    )
      .then((data) => setCalls(data))
      .catch((err) => logError(`Error fetching call data extraction`, err))
  }, [])

  const transcribeCall = async (callId: string) => {
    try {
      await queueCallProcessing(callId, 'transcribe')
      notifySuccess(`Transcription queued`)
    } catch (error) {
      logError(`Could not queue transcription`, error)
      notifyError(error instanceof Error ? error.message : `Could not queue transcription`)
    }
  }

  return { calls, transcribeCall }
}
